import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface ReturnOrderReceiptState extends ListState<any> {
    lineTotalCount: number,
    lineCurrentPage: number,
    linePageSize: number,
    lineList: Array<any>,
    lineLoading: boolean,

}
class ReturnOrderReceiptModule extends ListModule<ReturnOrderReceiptState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,

    lineTotalCount: 0,
    lineCurrentPage: 1,
    linePageSize: 10,
    lineList: new Array<any>(),
    lineLoading: false,

  };
  actions = {
    async get(context: ActionContext<ReturnOrderReceiptState, any>, payload: any) {
      let reponse=await Ajax.get(`/api/services/app/ReturnOrderReceipt/${payload.data.id}` );
      return reponse.data.result ;
  },
    async getAll(
      context: ActionContext<ReturnOrderReceiptState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/ReturnOrderReceipt/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getAllLines(
      context: ActionContext<ReturnOrderReceiptState, any>,
      payload: any
    ) {
      context.state.lineLoading = true;
      const {
        data: { result },
      } = await Ajax.get(`/api/services/app/ReturnOrderReceipt/${payload.data.id}/getAll-lines`, {
        params: payload.data,
      });
      context.state.lineLoading = false;
      const page = result as PageResult<any>;
      context.state.lineTotalCount = page.totalCount;
      context.state.lineList = page.items;
    },
  };

  mutations = {
    setCurrentPage(state: ReturnOrderReceiptState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ReturnOrderReceiptState, pagesize: number) {
      state.pageSize = pagesize;
    },
    setLineCurrentPage(state: ReturnOrderReceiptState, page: number) {
      state.lineCurrentPage = page;
    },
    setLinePageSize(state: ReturnOrderReceiptState, pagesize: number) {
      state.linePageSize = pagesize;
    },
  };
}
const returnOrderReceiptModule = new ReturnOrderReceiptModule();
export default returnOrderReceiptModule;
